import type { VisitLocation } from '@/services/ProposalService';

/** Server marker for "looked up, but no location" (private/unresolvable IP). */
export const UNKNOWN_COUNTRY_CODE = 'ZZ';

/**
 * Display label for a visit's approximate location:
 *   "Texas, United States" · "Ontario, Canada" · "Germany" · "Unknown location".
 * Returns null for visits recorded before location tracking existed.
 */
export function formatVisitLocation(location: Partial<VisitLocation> | null | undefined): string | null {
  const code = location?.country_code;
  if (!code) return null;
  if (code === UNKNOWN_COUNTRY_CODE) return 'Unknown location';
  const country = location?.country_name || code;
  return location?.region_name ? `${location.region_name}, ${country}` : country;
}
